'use es6';

import PropTypes from 'prop-types';
import { getColors } from 'reporting-ui-components/reports/utils/colors/chartColors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CombinationChartIcon = ({
  colorSeriesType = 'DEFAULT',
  size = 25
}) => {
  const colors = getColors(colorSeriesType, [0, 1]);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx("svg", {
      width: size,
      height: size,
      viewBox: "0 0 25 21",
      children: /*#__PURE__*/_jsx("g", {
        id: "CombinationSVG",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        children: /*#__PURE__*/_jsxs("g", {
          id: "Group-5",
          children: [/*#__PURE__*/_jsx("rect", {
            id: "Rectangle-2-Copy",
            fill: colors[0],
            transform: "translate(3.000000, 18.000000) rotate(-90.000000) translate(-3.000000, -18.000000) ",
            x: "0",
            y: "16",
            width: "6",
            height: "4"
          }), /*#__PURE__*/_jsx("rect", {
            id: "Rectangle-2-Copy-2",
            fill: colors[0],
            transform: "translate(9.000000, 19.000000) rotate(-90.000000) translate(-9.000000, -19.000000) ",
            x: "7",
            y: "17",
            width: "4",
            height: "4"
          }), /*#__PURE__*/_jsx("rect", {
            id: "Rectangle-2-Copy-3",
            fill: colors[0],
            transform: "translate(15.000000, 14.000000) rotate(-90.000000) translate(-15.000000, -14.000000) ",
            x: "8",
            y: "12",
            width: "14",
            height: "4"
          }), /*#__PURE__*/_jsx("rect", {
            id: "Rectangle-2-Copy-4",
            fill: colors[0],
            transform: "translate(21.000000, 17.000000) rotate(-90.000000) translate(-21.000000, -17.000000) ",
            x: "17",
            y: "15",
            width: "8",
            height: "4"
          }), /*#__PURE__*/_jsx("path", {
            d: "M22.6865065,0.899750562 C23.0869747,0.519430081 23.719929,0.535763032 24.1002494,0.936231228 C24.4805699,1.33669943 24.464237,1.96965371 24.0637688,2.34997419 L12.9608123,12.8943365 C12.7078851,13.1345388 12.3480726,13.225591 12.0113369,13.1346056 L0.908380386,10.1346056 C0.375215243,9.99054524 0.0597834576,9.44154553 0.203843775,8.90838039 C0.347904092,8.37521524 0.896903799,8.05978346 1.43006894,8.20384377 L11.9908134,11.057339 L22.6865065,0.899750562 Z",
            id: "Path-3",
            fill: colors[1],
            fillRule: "nonzero",
            transform: "translate(12.272057, 6.897052) rotate(-180.000000) translate(-12.272057, -6.897052) "
          })]
        })
      })
    })
  });
};
CombinationChartIcon.propTypes = {
  size: PropTypes.number,
  colorSeriesType: PropTypes.string
};
export default CombinationChartIcon;